import { render, staticRenderFns } from "./consultProductMsg.vue?vue&type=template&id=07a21a44&scoped=true"
import script from "./consultProductMsg.vue?vue&type=script&lang=js"
export * from "./consultProductMsg.vue?vue&type=script&lang=js"
import style0 from "./consultProductMsg.vue?vue&type=style&index=0&id=07a21a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a21a44",
  null
  
)

export default component.exports